import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./Main4.module.scss";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "layouts/wrapper/P";
import Center from "layouts/wrapper/Center";
import Dummy from "layouts/wrapper/Dummy";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { Waypoint } from "react-waypoint";
import ProgressbarSwiper from "routes/swiper/ProgressBarSwiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { brands } from "data/brands";
import { useNavigate } from "react-router-dom";
import { rpad2D } from "utils/Utils";
import Container from "layouts/container/Container";
import { useTranslation } from "react-i18next";
import Inline from "layouts/wrapper/Inline";
import investIcon from "resources/puffu/icon/invest.png";
import peopleIcon from "resources/puffu/icon/people.png";
import tradeIcon from "resources/puffu/icon/trade.png";
import itemsIcon from "resources/puffu/icon/items.png";
import companyIcon from "resources/puffu/icon/company.png";
import clsx from "classnames";

function Section5() {
    const { isMobile } = useContext(BrowserDetectContext);
    const [restockSlide, setRestockSlide] = useState([]);
    const navigate = useNavigate();
    const [isAnimated, setIsAnimated] = useState(false);
    const { t } = useTranslation();
    const swiperRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleSlideChange = (swiper) => {
        setActiveIndex(swiper.realIndex);
    };

    useEffect(() => {
        const swiperInstance = swiperRef.current?.swiper;
        if (swiperInstance) {
            swiperInstance.on('slideChange', () => handleSlideChange(swiperInstance));

            // 초기 활성 슬라이드 설정
            handleSlideChange(swiperInstance);

            return () => {
                swiperInstance.off('slideChange', () => handleSlideChange(swiperInstance));
            };
        }
    }, []);
    useEffect(() => {
        console.log(isAnimated);
    },[isAnimated])
    useEffect(() => {
        setRestockSlide(rpad2D(brands, isMobile ? 1 : 5, null));
    }, [isMobile]);

    const onEnter = () => {
        setIsAnimated(true);
    }
    const Row = (props) => {
        return (
            <VerticalFlex gap={5}>
                <FlexChild>
                    <HorizontalFlex gap={isMobile ? 15 : 35} padding={"15px"}>
                        <FlexChild width={"max-content"}>
                            {
                                isMobile
                                    ?
                                    <div className={clsx(style.mobileCheckbox, { [style.animated]: isAnimated })}>
                                        <div style={{ animationDelay: `${props.delay * 2}s` }} className={style.mobileCheckmark1}></div>
                                        <div style={{ animationDelay: `${props.delay}s` }} className={style.mobileCheckmark2}></div>
                                    </div>
                                    :
                                    <div className={clsx(style.checkbox, { [style.animated]: isAnimated })}>
                                        <div style={{ animationDelay: `${props.delay * 2}s` }} className={style.checkmark1}></div>
                                        <div style={{ animationDelay: `${props.delay}s` }} className={style.checkmark2}></div>
                                    </div>
                            }
                        </FlexChild>
                        <FlexChild width={"max-content"} justifyContent={"center"}>
                            {
                                props.companyIcon

                                    ?
                                    <div style={{ width: !isMobile ? "50px" : "30px", display: "flex", justifyContent: "flex-start", padding: "0 0 0 5px" }}>
                                        <img src={props.img} width={isMobile ? "30px" : props.iconWidth ? props.iconWidth : null} />
                                    </div>
                                    :
                                    <img src={props.img} width={isMobile ? "30px" : props.iconWidth ? props.iconWidth : "40px"} />
                            }

                        </FlexChild>

                        {
                            isMobile
                                ?
                                <FlexChild>
                                    <Center width={"100%"}>
                                        <Inline textAlign={"left"}>
                                            <P textAlign={"left"} size={isMobile ? "min(4vw, 20px)" : 30} padding={props.tradeIcon ? !isMobile ? "0 0 0 5px" : null : props.investIcon ? "0 0 0 0" : null} weight={"bold"}>{props.boldText}</P>
                                            <P textAlign={"left"} size={isMobile ? "min(4vw, 24px)" : 30}>{props.text1}</P>
                                        </Inline>
                                        <P textAlign={"left"} padding={props.tradeIcon ? !isMobile ? "0 0 0 5px" : null : props.investIcon ? "0 0 0 0" : null} size={isMobile ? "min(4vw, 20px)" : 30}>{props.text2}</P>
                                    </Center>
                                </FlexChild>
                                :

                                isAnimated && (
                                    <FlexChild >
                                        <div className={style.animatedText} style={{display: "flex", animationDelay: `${props.delay}s`}}>
                                            <P padding={props.tradeIcon ? !isMobile ? "0 0 0 5px" : null : props.investIcon ? "0 0 0 0" : null} size={isMobile ? "min(2.5vw, 20px)" : 28} weight={"bold"}>{props.boldText}</P>
                                            <Inline>
                                                <P size={isMobile ? "min(2.5vw, 20px)" : 28}>{props.text1} </P>
                                                <P size={isMobile ? "min(2.5vw, 20px)" : 28}>{props.text2}</P>
                                            </Inline>
                                        </div>
                                    </FlexChild>
                                )


                        }


                    </HorizontalFlex>
                </FlexChild>
                <FlexChild width={"100%"} height={"1.5px"} backgroundColor={"#ddd"} />
            </VerticalFlex>
        );
    }

    const BrandCard = ({ brand }) => {
        const onClickBrand = () => {
            // brand.logo && navigate("brand/" + brand.id);
        }

        return (
            <div>
                <div className={isMobile ? null : style.brandCard} onClick={onClickBrand} style={{ cursor: "pointer", borderRadius: "10px", display: "flex", justifyContent: "center" }}>
                    <img src={brand.thumbnail} width={isMobile ? "200px" : "100%"} style={{ borderRadius: !isMobile && "10px" }} />
                </div>
                <Dummy height={"25px"} />
                <P weight={"bold"}>{brand.title && t(brand.title.text)}</P>
                <Dummy height={"5px"} />
                <div style={{ display: "flex", flexWrap: "wrap", gap: "3px", justifyContent: "center", height: "30px", width: "100%" }}>
                    {
                        brand.products && brand.products.map((product, index) => {
                            // 제품 타이틀 뒤에 쉼표를 추가하는 조건을 설정
                            const productTitle = index === brand.products.length - 1 ? product.title : `${product.title},`;
                            return (
                                <div style={{ display: "flex" }}>
                                    <P size={10}>{productTitle}</P>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    return (
        <Container backgroundColor={"rgba(252, 251, 247, 1)"}>
            <Container maxWidth={1200}>

                <div className={style.sectionWrap} style={{ padding: "120px 0" }}>
                    <VerticalFlex gap={20}>
                        {/* <FlexChild width={"90%"}>
                            <VerticalFlex gap={20}>
                                <FlexChild>
                                    <P size={35} weight={"bold"}>PUFFU 제품 라인업</P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <div style={{ width: "100%", maxWidth: "1200px" }}>
                                <div style={{ position: "relative", padding: "0 20px" }}>

                                    {
                                        isMobile
                                            ?
                                            <div className="mobile-design-slider-container">
                                                <Swiper
                                                    // navigation
                                                    spaceBetween={10}
                                                    slidesPerView={1.5} // 슬라이드의 양옆에 일부가 보이도록 설정
                                                    centeredSlides={true} // 중앙에 슬라이드를 배치
                                                    loop={true}
                                                    onSwiper={(swiper) => {
                                                        swiperRef.current = swiper;
                                                        setActiveIndex(swiper.realIndex); // 초기 활성 슬라이드 설정
                                                    }}
                                                    onSlideChange={(swiper) => handleSlideChange(swiper)} // 슬라이드 변경 시 이벤트 핸들러 추가
                                                >
                                                    {brands && brands.map((brand, index) => {
                                                        return (
                                                            <SwiperSlide key={index}>
                                                                <HorizontalFlex gap={10} padding={"45px 0"}>
                                                                    <div
                                                                        key={index}
                                                                        className={`design-slider-slide ${activeIndex === index ? 'design-slider-slide-active' : ''}`}
                                                                        style={{
                                                                            transform: activeIndex === index ? 'scale(1)' : 'scale(0.85)',
                                                                            // filter: activeIndex === index ? 'none' : 'blur(4px)',
                                                                            opacity: activeIndex === index ? 1 : 0.3

                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <div
                                                                                className={isMobile ? null : style.brandCard}
                                                                                style={{
                                                                                    cursor: "pointer",
                                                                                    borderRadius: "10px",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={brand.thumbnail}
                                                                                    style={{ borderRadius: "10px" }}
                                                                                />
                                                                            </div>
                                                                            <Dummy height={"15px"} />
                                                                            <P weight={"bold"}>{brand.title && t(brand.title.text)}</P>
                                                                            <Dummy height={"5px"} />
                                                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "3px", justifyContent: "center", height: "30px", width: "100%" }}>
                                                                                {brand.products && brand.products.map((product, index) => {
                                                                                    // 제품 타이틀 뒤에 쉼표를 추가하는 조건을 설정
                                                                                    const productTitle = index === brand.products.length - 1 ? product.title : `${product.title},`;
                                                                                    return (
                                                                                        <div key={index} style={{ display: "flex" }}>
                                                                                            <P size={10}>{productTitle}</P>
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </HorizontalFlex>
                                                            </SwiperSlide>
                                                        );

                                                    })}





                                                </Swiper>
                                                <div className="mobile-design-slider-mask left"></div>
                                                <div className="mobile-design-slider-mask right"></div>
                                            </div>
                                            :
                                            <ProgressbarSwiper totalSlides={restockSlide.length}>
                                                {
                                                    restockSlide && restockSlide.map((slide, index) =>

                                                        <SwiperSlide key={index}>
                                                            <HorizontalFlex gap={10} padding={"45px 0"}>
                                                                {
                                                                    slide.map((brand, index) =>
                                                                        <SwiperSlide key={index}>
                                                                            <BrandCard brand={brand} />
                                                                        </SwiperSlide>
                                                                    )
                                                                }
                                                            </HorizontalFlex >
                                                        </SwiperSlide>

                                                    )
                                                }
                                            </ProgressbarSwiper>
                                    }

                                </div>
                            </div>
                        </FlexChild> */}
                        <FlexChild>
                            <div style={{ width: "80%", backgroundColor: !isMobile && "white", padding: !isMobile && "100px 50px", borderRadius: "15px" }}>
                                <Waypoint onEnter={onEnter} />
                                <VerticalFlex gap={15}>

                                    <FlexChild>
                                        <P weight={"bold"} size={isMobile ? "min(6vw, 30px)" : 36}>이런 분들께 추천드립니다!</P>
                                        <Dummy height={"40px"} />
                                    </FlexChild>
                                    <FlexChild height={"1.5px"} width={"100%"} backgroundColor={"#ddd"} />
                                    <FlexChild>
                                        <Row img={investIcon} boldText={isMobile ? "소규모 투자 자금" : "  소규모 투자 자금"} text1={"으로"} text2={"사업을 준비하는 분"} delay={0.2} />
                                    </FlexChild>
                                    <FlexChild>
                                        <Row investIcon img={peopleIcon} boldText={isMobile ? "인건비 부담 없이" : "  인건비 부담 없이"} text2={"사업운영을 원하시는 분"} delay={0.2} />
                                    </FlexChild>
                                    <FlexChild>
                                        <Row tradeIcon img={tradeIcon} boldText={isMobile ? "업종변경" : " 업종변경"} text1={"을"} text2={"고민중이신 분"} delay={0.2} />
                                    </FlexChild>
                                    <FlexChild>
                                        <Row img={investIcon} boldText={isMobile ? "차별화된 사업 아이템" : "  차별화된 사업 아이템"} text1={"을"} text2={"찾는 분"} delay={0.2} />
                                    </FlexChild>
                                    <FlexChild>
                                        <Row companyIcon img={companyIcon} boldText={isMobile ? "회사 생활과 사업, 투잡" : "회사 생활과 사업, 투잡"} text1={"을"} text2={"계획하시는 분"} delay={0.2} />
                                    </FlexChild>
                                </VerticalFlex>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </div>

            </Container>
        </Container>
    );
}

export default Section5;